import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import { NHAUserProfileMenuComponent } from './user-profile-menu.component';
import { NHAAuthModule } from '@nha/auth';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	imports: [CommonModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatIconModule, MatTooltipModule, NHAAuthModule, NHAUserProfileMenuComponent],
	exports: [NHAUserProfileMenuComponent]
})
export class NHAUserProfileMenuModule {}
